export default __webpack_public_path__ + "static/media/logo-white.1bcd8a45.png";